<div class="card-verification-settings">
  <div class="page-title">Verificação de cartão no cadastro</div>
  <p class="page-description">
    Controle operacional da validação de cartão na aquisição. As alterações são
    aplicadas em tempo real pela subscription-api.
  </p>

  <div class="config-list" *ngIf="configs?.length">
    <div class="config-card" *ngFor="let config of configs">
      <div class="config-card__header">
        <div>
          <h3>{{ config.name }}</h3>
          <small>{{ config.configKey }}</small>
        </div>
        <p-inputSwitch
          [ngModel]="config.isEnabled"
          (ngModelChange)="onToggle(config, $event)"
          [disabled]="saving[config.configurationId]"
        />
      </div>
      <p class="config-card__description">{{ config.description }}</p>
      <small *ngIf="config.dateUpdated" class="config-card__updated">
        Última atualização: {{ config.dateUpdated | date: 'dd/MM/yyyy HH:mm' }}
      </small>
    </div>
  </div>
</div>
<p-toast />
